<template>
  <router-link to="/">
    <img
      class="img-fluid"
      src="@/assets/images/logo-dark.png"
      alt=""
      style="width: 160px"
    />
  </router-link>
</template>
<script>
export default {
  name: "Logo",
};
</script>
